module.exports = __webpack_public_path__ + "img/transition_to_S+P.ad6f95fa.svg";